import React, { useState, useRef, useContext } from 'react';
import { useTranslation} from 'react-i18next';
import { toast } from 'react-toastify';
import SubscriptionContext from '../context';
import Refresh from '@material-ui/icons/Refresh';
import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import { showSubscription, editSubscription, createSubscription } from '~/config/routes';
import { lookupLanguages, lookupCurrencies } from '../utils/makeOptions';
import moment from 'moment';
import { AbilityContext } from '~/contexts/Can';

function SubscriptionList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(SubscriptionContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`subscription.attributes.${attr}`);

  function handleDeletionModal(id, name){
    setModalInfo({ show: true, id, name });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/plans/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Subscriptions')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Subscriptions')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Subscriptions')) {
    actions.push('del');
  }
  if(ability.can('show', 'Subscriptions')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createSubscription}
        routeToEdit={editSubscription}
        routeToShow={showSubscription}
        listEl={listEl}
        path={'/admin/plans/'}
        actions={actions}
        paperProps={{
          Icon: Refresh,
          iconColor: 'blue',
          title: t('subscription.defPlural'),
        }}
        columns={[
          { title: trAttr('is_active'), field: 'is_active', type: 'boolean' },
          { title: trAttr('name'), field: 'name', type: 'string' },
          { title: trAttr('lang'), field: 'lang', type: 'string', lookup: lookupLanguages, render: rowData => <label>{t(`language.${rowData.lang}`)}</label>}, // eslint-disable-line
          { title: trAttr('coin'), field: 'coin', type: 'string', lookup: lookupCurrencies, render: rowData => <label>{t(`list_currency.${rowData.coin}`)}</label>}, // eslint-disable-line
          { title: trAttr('month_price'), field: 'month_price', type: 'currency'},
          { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime' },
        ]}
        context={SubscriptionContext}
        recordMap={
          record => ({
            ...record,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />
      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.name}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(SubscriptionList);
